import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import  './product.css';
import { defaultHeaders } from './util';
import * as util from "./util";
import './product-details.css';
import { Stars } from './stars';
import { StaticStars } from './static-stars';
import { ReviewEntry } from './review';


export class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.getProductDetails = this.getProductDetails.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      id: this.props.params['id'],
      name: '',
      board: '',
      uuid: '',
      type: '',
      description: '',
      is_separate_sw: '',
      separate_sw: '',
      has_update_offer: '',
      update_offer: '',
      price_update: 0,
      sw_type: '',
      is_kommune: '',
      tags: [],
      price: 0,
      price_from: 0,
      price_to: 0,
      direct_database_access: '',
      direct_database_access_desc: '',
      has_additional_interface: '',
      additional_interface: '',
      has_additional_licence: '',
      additional_licence: '',
      data_component_complete: '',
      data_component_options: '',
      data_manupulation: '',
      data_manupulation_protocol: '',
      manipulation_authorised: '',
      manipulation_authorised_desc: '',
      data_update_interval: 0,
      has_update_side_effect: '',
      update_side_effect: '',
      has_release_plan: '',
      release_plan: '',
      is_preparation_needed: '',
      preparation_needed: '',
      has_customer_reference: '',
      customer_reference: '',
      service_customer_reference: '',
      service_expertise: '',
      warrantor: '',
      successful_deployment: '',
      successful_deployment_description: '',
      clinic_count: '',
      clinic_count_description: '',
      statistic_user_counts: '',
      user_satisfaction: '',
      user_satisfaction_desc: '',
      sw_date: '',
      complexity_rate: '',
      referenced_services: [],
      statistics: '',
      referenced_software: [],
      reviews: '',
      numberOfStars: 0,

    }

    this.getProductDetails(this.props.params['id']);
  }

  componentWillReceiveProps(nextProps) {
    const newID = parseInt(nextProps.params['id'], 10);
    const oldID = parseInt(this.state.id, 10);
    if (oldID !== newID) {
      this.getProductDetails(newID);
      this.setState({ id: newID });
    }
  }

  getProductDetails(productID) {
    const self = this;
    const url = `/api/get-product-details?id=${productID}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        console.error('Could not product details.', exception);
      });

    promise.then(function (json) {
      const obj = JSON.parse(json[5][1]);
      self.setState({
        name: (obj.name ? obj.name : '(kein Name)'),
        board: obj.board ? obj.board : '',
        uuid: obj.uuid ? obj.uuid : '',
        type: (obj.type ? obj.type : '(von unbekanntem Typ)'),
        description: (obj.description ? obj.description : '(keine Beschreibung)'),
        is_separate_sw: (obj.is_separate_sw ? obj.is_separate_sw : '(keine Angabe)'),
        separate_sw: (obj.separate_sw ? obj.separate_sw : '(keine Beschreibung)'),
        has_update_offer: (obj.has_update_offer ? obj.has_update_offer : '(keine Angabe)'),
        update_offer: (obj.update_offer ? obj.update_offer : '(keine Beschreibung)'),
        price_update: (obj.price_update ? obj.price_update : '(keine Angabe)'),
        sw_type: (obj.sw_type ? obj.sw_type : '(keine Angabe)'),
        is_kommune: (obj.is_kommune ? obj.is_kommune : '(keine Angabe)'),
        tags: (obj.tags ? obj.tags : '(keine Angabe)'),
        price: (obj.price ? obj.price : '(kein Preis Angegeben)'),
        price_from: (obj.price_from ? obj.price_from : '(keine Angabe)'),
        price_to: (obj.price_to ? obj.price_to : '(keine Angabe)'),
        direct_database_access: (obj.direct_database_access ? obj.direct_database_access : '(keine Angabe)'),
        direct_database_access_desc: (obj.direct_database_access_desc ? obj.direct_database_access_desc : '(keine Beschreibung)'),
        has_additional_interface: (obj.has_additional_interface ? obj.has_additional_interface : '(keine Angabe)'),
        additional_interface: (obj.additional_interface ? obj.additional_interface : '(keine Beschreibung)'),
        has_additional_licence: (obj.has_additional_licence ? obj.has_additional_licence : '(keine Angabe)'),
        additional_licence: (obj.additional_licence ? obj.additional_licence : '(keine Beschreibung)'),
        data_component_complete: (obj.data_component_complete ? obj.data_component_complete : '(keine Angabe)'),
        data_component_options: (obj.data_component_options ? obj.data_component_options : '(keine Beschreibung)'),
        data_manupulation: (obj.data_manupulation ? obj.data_manupulation : '(keine Angabe)'),
        data_manupulation_protocol: (obj.data_manupulation_protocol ? obj.data_manupulation_protocol : '(keine Beschreibung)'),
        manipulation_authorised: (obj.software_manipulation_authorised ? obj.software_manipulation_authorised : '(keine Angabe)'),
        manipulation_authorised_desc: (obj.manipulation_authorised_desc ? obj.manipulation_authorised_desc : '(keine Beschreibung)'),
        data_update_interval: (obj.data_update_interval ? obj.data_update_interval : '(keine Angabe)'),
        has_update_side_effect: (obj.has_update_side_effect ? obj.has_update_side_effect : '(keine Angabe)'),
        update_side_effect: (obj.update_side_effect ? obj.update_side_effect : '(keine Beschreibung)'),
        has_release_plan: (obj.has_release_plan ? obj.has_release_plan : '(keine Angabe)'),
        release_plan: (obj.release_plan ? obj.release_plan : '(keine Beschreibung)'),
        is_preparation_needed: (obj.is_preparation_needed ? obj.is_preparation_needed : '(keine Angabe)'),
        preparation_needed: (obj.preparation_needed ? obj.preparation_needed : '(keine Beschreibung)'),
        has_customer_reference: (obj.has_customer_reference ? obj.has_customer_reference : '(keine Angabe)'),
        customer_reference: (obj.customer_reference ? obj.customer_reference : '(keine Beschreibung)'),
        warrantor: (obj.warrantor ? obj.warrantor : '(keine Angabe)'),
        successful_deployment: (obj.successful_deployment ? obj.successful_deployment : '(keine Angabe)'),
        successful_deployment_description: (obj.successful_deployment_description ? obj.successful_deployment_description : '(keine Beschreibung)'),
        clinic_count: (obj.clinic_count ? obj.clinic_count : '(keine Angabe)'),
        clinic_count_description: (obj.clinic_count_description ? obj.clinic_count_description : '(keine Beschreibung)'),
        statistic_user_counts: (obj.statistic_user_counts ? obj.statistic_user_counts : '(keine Angabe)'),
        user_satisfaction: (obj.user_satisfaction ? obj.user_satisfaction : '(keine Angabe)'),
        user_satisfaction_desc: (obj.user_satisfaction_desc ? obj.user_satisfaction_desc : '(keine Beschreibung)'),
        sw_date: (obj.sw_date ? obj.sw_date : '(keine Angabe)'),
        complexity_rate: (obj.complexity_rate ? obj.complexity_rate : '(keine Angabe)'),
        referenced_services: obj.referenced_services,
        service_customer_reference: (obj.service_customer_reference ? obj.service_customer_reference : '(keine Angabe)'),
        service_expertise: (obj.service_expertise ? obj.service_expertise : '(keine Angabe)'),
        referenced_software: (obj.referenced_software ? obj.referenced_software : '(keine Angabe)'),
      });
      return;
    });
    return;
  }

  onSubmit(review, numberOfStars) {
    this.setState({
      review: review,
      numberOfStars: numberOfStars
    })
  }

  render() {
    if (this.state.type === "Dienstleistung Alt") {
      return (
        <div className="ProductDetails" id="mobileProductDetails">
          <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} productName={this.state.name} productType={this.state.type} />
          <ProductType name={this.state.name} productType={this.state.type} />
          {!util.isGuestUser() && <ProductPriceService price_from={this.state.price_from} price_to={this.state.price_to} />}
          {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
          <ProductRating uuid={this.state.uuid} />
          <ProductTabsService
              productID={this.state.id}
              uuid={this.state.uuid}
              description={this.state.description}
              tags={this.state.tags}
              service_customer_reference={this.state.service_customer_reference}
              service_expertise={this.state.service_expertise}
              warrantor={this.state.warrantor}
              referenced_software={this.state.referenced_software} />
          {/* <InfoBar faq={faqProductDetails} />*/}
        </div>
      );
    }
    return (
      <div className="ProductDetails" id="mobileProductDetails">
        <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} productName={this.state.name} productType={this.state.type}/>
        <ProductType name={this.state.name} productType={this.state.type} />
        {!util.isGuestUser() && <ProductPrice price={this.state.price} />}
        {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
        <ProductRating uuid={this.state.uuid} />
        <ProductTabsSoftware
            productID={this.state.id}
            description={this.state.description}
            is_separate_sw={this.state.is_separate_sw}
            separate_sw={this.state.separate_sw}
            has_update_offer={this.state.has_update_offer}
            update_offer={this.state.update_offer}
            price_update={this.state.price_update}
            sw_type={this.state.sw_type}
            is_kommune={this.state.is_kommune}
            tags={this.state.tags}
            direct_database_access={this.state.direct_database_access}
            direct_database_access_desc={this.state.direct_database_access_desc}
            has_additional_interface={this.state.has_additional_interface}
            additional_interface={this.state.additional_interface}
            has_additional_licence={this.state.has_additional_licence}
            additional_licence={this.state.additional_licence}
            data_component_complete={this.state.data_component_complete}
            data_component_options={this.state.data_component_options}
            data_manupulation={this.state.data_manupulation}
            data_manupulation_protocol={this.state.data_manupulation_protocol}
            manipulation_authorised={this.state.manipulation_authorised}
            manipulation_authorised_desc={this.state.manipulation_authorised_desc}
            data_update_interval={this.state.data_update_interval}
            has_update_side_effect={this.state.has_update_side_effect}
            update_side_effect={this.state.update_side_effect}
            has_release_plan={this.state.has_release_plan}
            release_plan={this.state.release_plan}
            is_preparation_needed={this.state.is_preparation_needed}
            preparation_needed={this.state.preparation_needed}
            has_customer_reference={this.state.has_customer_reference}
            customer_reference={this.state.customer_reference}
            successful_deployment={this.state.successful_deployment}
            successful_deployment_description={this.state.successful_deployment_description}
            clinic_count={this.state.clinic_count}
            clinic_count_description={this.state.clinic_count_description}
            statistic_user_counts={this.state.statistic_user_counts}
            user_satisfaction={this.state.user_satisfaction}
            user_satisfaction_desc={this.state.user_satisfaction_desc}
            sw_date={this.state.sw_date}
            complexity_rate={this.state.complexity_rate}
            referenced_services={this.state.referenced_services} />
        {/*<InfoBar faq={faqProductDetails} />*/}
      </div>
    )
  }
}


class ProductTabsSoftware extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
      <div className="ProductTabs">
        <div className="ProductTabsButtons">
          <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
          <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Technische Details</button>
          <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} >Referenz</button>
          <button className={this.state.activeTab === 3 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(3)} >Statistik</button>
          <button className={this.state.activeTab === 4 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(4)} >ref. Dienstleistungen</button>
          <button className={this.state.activeTab === 5 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(5)} >Reviews</button>
          <button className={this.state.activeTab === 6 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(6)} style={{ textDecoration: 'line-through' }}>Medien</button>
          <ProductDescriptionSoftware style={this.state.activeTab === 0 ? null : { display: 'none' }}
                                      description={this.props.description}
                                      is_separate_sw={this.props.is_separate_sw}
                                      separate_sw={this.props.separate_sw}
                                      has_update_offer={this.props.has_update_offer}
                                      update_offer={this.props.update_offer}
                                      price_update={this.props.price_update}
                                      sw_type={this.props.sw_type}
                                      is_kommune={this.props.is_kommune}
                                      tags={this.props.tags} />
          <ProductTechnicalDetails style={this.state.activeTab === 1 ? null : { display: 'none' }}
                                   direct_database_access={this.props.direct_database_access}
                                   direct_database_access_desc={this.props.direct_database_access_desc}
                                   has_additional_interface={this.props.has_additional_interface}
                                   additional_interface={this.props.additional_interface}
                                   has_additional_licence={this.props.has_additional_licence}
                                   additional_licence={this.props.additional_licence}
                                   data_component_complete={this.props.data_component_complete}
                                   data_component_options={this.props.data_component_options}
                                   data_manupulation={this.props.data_manupulation}
                                   data_manupulation_protocol={this.props.data_manupulation_protocol}
                                   manipulation_authorised={this.props.manipulation_authorised}
                                   manipulation_authorised_desc={this.props.manipulation_authorised_desc}
                                   data_update_interval={this.props.data_update_interval}
                                   has_update_side_effect={this.props.has_update_side_effect}
                                   update_side_effect={this.props.update_side_effect}
                                   has_release_plan={this.props.has_release_plan}
                                   release_plan={this.props.release_plan}
                                   is_preparation_needed={this.props.is_preparation_needed}
                                   preparation_needed={this.props.preparation_needed} />
          <ProductReferenceSoftware style={this.state.activeTab === 2 ? null : { display: 'none' }}
                                    has_customer_reference={this.props.has_customer_reference}
                                    customer_reference={this.props.customer_reference} />
          <ProductStatistics style={this.state.activeTab === 3 ? null : { display: 'none' }}
                             successful_deployment={this.props.successful_deployment}
                             successful_deployment_description={this.props.successful_deployment_description}
                             clinic_count={this.props.clinic_count}
                             clinic_count_description={this.props.clinic_count_description}
                             statistic_user_counts={this.props.statistic_user_counts}
                             user_satisfaction={this.props.user_satisfaction}
                             user_satisfaction_desc={this.props.user_satisfaction_desc}
                             sw_date={this.props.sw_date}
                             complexity_rate={this.props.complexity_rate} />
          <ProductServices key={this.props.productID} style={this.state.activeTab === 4 ? null : { display: 'none' }}
                           referenced_services={this.props.referenced_services} />
          <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 5 ? null : { display: 'none' }} />
          <ProductMedia style={this.state.activeTab === 6 ? null : { display: 'none' }} />
        </div>
      </div>
    )
  }
}

class ProductTabsService extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
      <div className="ProductTabs">
        <div className="ProductTabsButtons">
          <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
          <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Referenz</button>
          <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} style={{ textDecoration: 'line-through' }}>ref. Software</button>
          <button className={this.state.activeTab === 3 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(3)} style={{ textDecoration: 'line-through' }}>Medien</button>
          <button className={this.state.activeTab === 4 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(4)} >Reviews</button>
          <ProductDescriptionService style={this.state.activeTab === 0 ? null : { display: 'none' }}
                                     description={this.props.description}
                                     service_expertise={this.props.service_expertise}
                                     tags={this.props.tags} />
          <ProductReferenceService style={this.state.activeTab === 1 ? null : { display: 'none' }}
                                   service_customer_reference={this.props.service_customer_reference}
                                   warrantor={this.props.warrantor} />
          <ProductSoftware style={this.state.activeTab === 2 ? null : { display: 'none' }} />
          <ProductMedia style={this.state.activeTab === 3 ? null : { display: 'none' }} />
          <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 4 ? null : { display: 'none' }} />
        </div>
      </div>
    )
  }
}



export class ProductType extends Component {
  render() {
    return (
      <div className="ProductType">
        <div className="">{this.props.name} <br /> ({this.props.productType})</div>
      </div>
    )
  }
}


export class ProductTypeWithoutParantheses extends Component {
  render() {
    return (
      <div className="ProductType">
        <div className="">{this.props.name} <br /> {this.props.productType}</div>
      </div>
    )
  }
}

export class ProductTypeWithLabel extends Component {
  render() {
    return (
      <div className="ProductType OpenSans Bold">
        <span className="">Typ</span>
        <span className="FontBlue marginLeft1">{this.props.productType}</span>
      </div>
    )
  }
}

export class ProductRating extends Component {
  render() {
    return (
      <div>
        <div className="Stars">
          <div className="Bold marginTop2"> Bewertung</div>
          <div className="marginTop1 marginLeft1"> <StaticStars uuid={this.props.uuid} /></div>
          </div>
        </div>
    )
  }
}

export class ProductDetailsButtons extends Component {
  constructor(props) {
    super(props);
    this.getPurchaseURL = this.getPurchaseURL.bind(this);
    this.getContactURL = this.getContactURL.bind(this);
    this.addBookmark = this.addBookmark.bind(this);
    this.state={purchaseURL: '',
                contactURL: '',
                board: '',
                productName: '',
                price: '',
                role_name: '',
                user_name: '',
                email: '',
                company: ''
    };
    this.getProductInfo(util.translateTypeIntoEnglish(this.props.productType), this.props.productID);
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.board !== this.state.board) {
      this.setState({ board: nextProps.board })
    }

    if (nextProps.productName !== this.state.productName || nextProps.price !== this.state.price) {
      this.setState({ productName: nextProps.productName, price: nextProps.price }, function () {
        if(!util.isGuestUser()) {
          this.getPurchaseURL();
          this.getContactURL();
        }
      })
    }
  }

  getPurchaseURL() {
    const url='/api/fill-purchase-template';
    var headers = util.defaultHeaders();
    var body = 'product_name='+encodeURIComponent(this.state.productName)+'&price='+this.state.price;

    headers.append("Content-Type", "application/x-www-form-urlencoded");
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: body
    })
      .then(response => response.json())
      .catch(function(exception) {
        console.error('Could not fill in template.', exception);
      })
    promise.then(json => json !== undefined ? this.setState({purchaseURL: `${json.url}`}) : null);
  }

  getContactURL() {
    const url='/api/fill-contact-template';
    var headers = util.defaultHeaders();
    var body = 'product_name='+encodeURIComponent(this.state.productName);
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body:body
    })
      .then(response => response.json())
      .catch(function(exception) {
        console.error('Could not fill in template.', exception);
      })
    promise.then(json => json !== undefined ? this.setState({contactURL: `${json.url}`}) : null);
  }

  addBookmark(productID, productType, productName) {
    const url = '/api/add-bookmark';
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${productID}&type=${util.translateTypeIntoEnglish(productType)}&name=${productName}`
    }).then(response => response.json())
      .catch(function (exception) {
        console.error('Could not bookmark product.', exception);
      })
      .then(json => null);
    return;
  }

  getProductInfo(table, id) {
    var self = this;
    fetch(`/api/get-product-info?table=${table}&id=${id}`, {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Could not get product infos. ", error))
      .then(function (json) {
        self.setState({
          role_name: (json[0].name ? json[0].name : ' (keine Angabe)'),
          user_name: (json[0].user_name ? json[0].user_name : ' (keine Angabe)'),
          email: (json[0].email ? json[0].email : ' (keine Angabe)'),
          company: (json[0].company ? json[0].company : ' (keine Angabe)')
        })
      });
  }

  render() {

    var self = this;

    return (
      <div className="ProductDetailButtons">
        {!util.isGuestUser() && this.state.role_name === 'none-commercial' &&
         <div className="button marginTop2" onClick={function (event) {
             setTimeout( function () {
               window.open(self.state.contactURL.replace(/html$/, 'pdf'), "_blank");
               self.addBookmark(self.props.productID, self.props.productType, self.props.productName);
             }, 3000);
           }} >
           <span
                 title="In einem neuen Tab wird ein Formular generiert, bitte das Formular ausdrucken und unterschrieben an Ayacandas zurück faxen: +49-211-547616-01." data-tooltip-position="bottom">ANBIETER KONTAKTIEREN &#9432;</span>
         </div>
        }
            {/* onClick={ () => this.props.history.push(`/board/${this.state.board}`)}*/}
          <div className="button marginTop2" onClick={(event) =>this.props.history.push('/board/' + this.state.board)}>
        <span >FORUM</span>
         </div>


        {!util.isGuestUser() && <div className="button marginTop2" onClick={() => {this.addBookmark(this.props.productID, this.props.productType, this.props.productName); alert('Bookmark wurde gesetzt.')} }>
           <span>BOOKMARK SETZEN</span>
         </div>
         }

         {!util.isGuestUser() &&
          <div className="button marginTop2"
               onClick={function (event) {
                   setTimeout( function () {
                     window.open(self.state.purchaseURL.replace(/html$/, 'pdf'), "_blank");
                     self.addBookmark(self.props.productID, self.props.productType, self.props.productName);
                   }, 3000);
                 }} >
            <span
                  title="In einem neuen Tab wird ein Formular generiert, bitte das Formular ausdrucken und unterschrieben an Ayacandas zurück faxen: +49-211-547616-01." data-tooltip-position="bottom">ANGEBOT ANFORDERN &#9432;</span>
          </div>
         }
      </div>
    )
  }
}

export class ProductDetailsButton extends Component {
  render() {
    return (
      <div className="button">
        <span style={this.props.style}>{this.props.text}</span>
      </div>
    )
  }
}

export class ProductDescriptionTender extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Beschreibung </label> <br /><span className="ProductDetailAnswers">{this.props.description} </span><br /></div>
        <br /><div className="DetailDiv"><label>Zweck </label> <br /><span className="ProductDetailAnswers">{this.props.aim} <br /></span></div>
        <br /><div className="DetailDiv"><label>Das Produkt ist primär für </label> <br /><span className="ProductDetailAnswers">{this.props.target_group}</span></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags}</span></div>
      </div>
    )
  }
}

export class ProductDescriptionSoftware extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Beschreibung </label> <br /><span className="ProductDetailAnswers">{this.props.description} </span><br /></div>
        <br /><div className="DetailDiv"><label>Diese Software kann für Käufer aus öffentlichen Institutionen (Gemeinden, Kommunen, Universitäten, Anstalten des Landes etc.) ohne Ausschreibung und direkt erworben werden </label> <br /> <span className="ProductDetailAnswers">{this.props.is_kommune === true ? 'Ja' : 'Nein'} </span></div>
        <br /><div className="DetailDiv"><label>ein eigenstehendes Produkt oder eine Implementation </label> <br /><span className="ProductDetailAnswers">{this.props.is_separate_sw === true ? 'Ja' : 'Nein'} <br /> {this.props.separate_sw}</span></div>
        <br /><div className="DetailDiv"><label>Gibt es Wartungen oder Updates? </label> <br /><span className="ProductDetailAnswers">{this.props.has_update_offer === true ? 'Ja' : 'Nein'} <br /> {this.props.update_offer}</span></div>
        <br /><div className="DetailDiv"><label>Kosten je Jahr </label> <br /><span className="ProductDetailAnswers">{this.props.price_update} &#8364;</span></div>
        <br /><div className="DetailDiv"><label>Das Produkt ist primär für </label> <br /><span className="ProductDetailAnswers">{this.props.sw_type}</span></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags}</span></div>
      </div>
    )
  }
}

export class ProductDescriptionService extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Beschreibung </label> <br /><span className="ProductDetailAnswers">{this.props.description}</span> <br /></div>
        <br /><div className="DetailDiv"><label>Auf bestimmte Bereiche spezialisiert </label> <br /><span className="ProductDetailAnswers">{this.props.service_expertise} </span><br /></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags} </span><br /></div>
      </div>
    )
  }
}

export class ProductDescriptionUsedSoftware extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Zweck der Software</label> <br /><span className="ProductDetailAnswers">{this.props.aim} <br /></span></div>
        <br /><div className="DetailDiv"><label>Die Software geschrieben von der Firma:</label> <br /><span className="ProductDetailAnswers">{this.props.company} <br /></span></div>
        <br /><div className="DetailDiv"><label>Die genaue Bezeichnung des Herstellers zu dieser Software:</label> <br /><span className="ProductDetailAnswers">{this.props.company_name} <br /></span></div>
        <br /><div className="DetailDiv"><label>Hersteller-Webseite zur genaueren Information über diese Software:</label> <br /><span className="ProductDetailAnswers">{this.props.company_web} <br /></span></div>
        <br /><div className="DetailDiv"><label>Ist die Software ein Medizinprodukt</label> <br /> <span className="ProductDetailAnswers">{this.props.is_public === true ? 'Ja' : 'Nein'}</span></div>
        <br /><div className="DetailDiv"><label>Braucht die Software ein Update, um auf einer aktuellen Version zu sein </label> <br /><span className="ProductDetailAnswers">{this.props.is_update_available === true ? 'Ja' : 'Nein'} <br /> <p>{this.props.update_price_text} </p></span></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags}</span></div>
      </div>
    )
  }
}

export class ProductDescriptionOther extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Beschreibung zu dem Produkt</label> <br /><span className="ProductDetailAnswers">{this.props.aim} <br /></span></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags}</span></div>
      </div>
    )
  }
}

export class ProductTechnicalDetails extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Gibt es einen direkten Datenbankzugriff? </label> <br /><span className="ProductDetailAnswers">{this.props.direct_database_access === true ? 'Ja' : 'Nein'}</span></div>
        <br /><div className="DetailDiv"><label>Art des Datenzugriffs </label> <br /><span className="ProductDetailAnswers">{this.props.direct_database_access_desc}</span></div>
        <br /><div className="DetailDiv"><label>Werden zusätzliche Schnittstellen benötigt? </label> <br /><span className="ProductDetailAnswers">{this.props.has_additional_interface === true ? 'Ja' : 'Nein'} <br /> {this.props.additional_interface}</span></div>
        <br /><div className="DetailDiv"><label>Werden zusätzliche Lizenzen benötigt? </label> <br /><span className="ProductDetailAnswers">{this.props.has_additional_licence === true ? 'Ja' : 'Nein'} <br /> {this.props.additional_licence}</span></div>
        <br /><div className="DetailDiv"><label>Werden alle Komponenten zum Datenzugriff geliefert? </label> <br /><span className="ProductDetailAnswers">{this.props.data_component_complete === true ? 'Ja' : 'Nein'} <br /> {this.props.data_component_options}</span></div>
        <br /><div className="DetailDiv"><label>Werden Daten am Quellsystem manipuliert? </label> <br /><span className="ProductDetailAnswers">{this.props.data_manupulation === true ? 'Ja' : 'Nein'} <br /> {this.props.data_manupulation_protocol}</span> </div>
        <br /><div className="DetailDiv"><label>Ist der Zugriff zu der Datenquelle authorisiert? </label> <br /><span className="ProductDetailAnswers">{this.props.manipulation_authorised === true ? 'Ja' : 'Nein'} <br /> {this.props.manipulation_authorised_desc}</span></div>
        <br /><div className="DetailDiv"><label>Aktualisierungsintervall in Minuten </label> <br /><span className="ProductDetailAnswers">{this.props.data_update_interval}</span></div>
        <br /><div className="DetailDiv"><label>Gibt es Aktualisierungsnebenwirkungen? </label> <br /><span className="ProductDetailAnswers">{this.props.has_update_side_effect === true ? 'Ja' : 'Nein'} <br /> {this.props.update_side_effect}</span></div>
        <br /><div className="DetailDiv"><label>Gibt es einen Releaseplan?</label> <br /> <span className="ProductDetailAnswers">{this.props.has_release_plan === true ? 'Ja' : 'Nein'} <br /> {this.props.release_plan}</span></div>
        <br /><div className="DetailDiv"><label>Sind weitere Vorbereitungen nötig</label> <br /><span className="ProductDetailAnswers"> {this.props.is_preparation_needed === true ? 'Ja' : 'Nein'} <br /> {this.props.preparation_needed}</span></div>
      </div>
    )
  }
}

class ProductReferenceSoftware extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>vorhandene Referenzen </label> <br /><span className="ProductDetailAnswers">{this.props.has_customer_reference === true ? 'Ja' : 'Nein'} </span> <br /> <span className="ProductDetailAnswers">{this.props.customer_reference}</span></div>
      </div>
    )
  }
}

export class ProductReferenceService extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>vorhandene Referenzen</label> <br /><span className="ProductDetailAnswers">{this.props.service_customer_reference}</span></div>
        <br /><div className="DetailDiv"><label>Bürgen als Referenz vorhanden</label> <br /><span className="ProductDetailAnswers">{this.props.warrantor}</span></div>
      </div>
    )
  }
}

export class ProductStatistics extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>wurde das Produkt schon erfolgreich eingesetzt </label> <br /><span className="ProductDetailAnswers">{this.props.successful_deployment === true ? 'Ja' : 'Nein'}</span> <br /> <span className="ProductDetailAnswers">{this.props.successful_deployment_description}</span></div>
        <br /><div className="DetailDiv"><label>welche sind die Einsatzbereiche Ihre Software </label> <br /><span className="ProductDetailAnswers">{this.props.clinic_count_description}</span></div>
        <br /><div className="DetailDiv"><label>wieviele Nutzer hat Ihre Software </label> <br /><span className="ProductDetailAnswers">{this.props.statistic_user_counts}</span></div>
        <br /><div className="DetailDiv"><label>wieviele davon sind Kliniken </label> <br /><span className="ProductDetailAnswers">{this.props.clinic_count} <br /></span> <span>{this.props.clinic_count_description}</span></div>
        <br /><div className="DetailDiv"><label>mittlere Zufriedenheit der Nutzer </label> <br /><span className="ProductDetailAnswers">{this.props.user_satisfaction}</span> <br /> <span>{this.props.user_satisfaction_desc}</span></div>
        <br /><div className="DetailDiv"><label>seit wann ist das Produkt in Nutzung </label> <br /><span className="ProductDetailAnswers">{this.props.sw_date}</span></div>
        <br /><div className="DetailDiv"><label>persönliche Komplexitätsbewertung </label> <br /><span className="ProductDetailAnswers">{this.props.complexity_rate}</span></div>
      </div>
    )
  }
}

export class ProductServices extends Component {
  constructor(props) {
    super(props);
    this.state = { services: [] };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      services: nextProps.referenced_services.map(function (obj) {
        const url = `/product-details/${obj.id}`;
        return <li key={Math.random()} title={obj.id}><Link to={url}>{obj.name}</Link></li>;
      })
    })
  }

  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <ul style={{ listStyleType: 'none', cursor: 'pointer' }}>
          <br /><div className="DetailDiv">{this.state.services} <br /></div>
        </ul>
      </div>
    )
  }
}

export class ProductSoftwareNew extends Component {
  constructor(props) {
    super(props);
    this.getReferencedSoftwareNames = this.getReferencedSoftwareNames.bind(this);
    this.state = {
      referenced_software: [],
      names: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      referenced_software: nextProps.referenced_software.toString().split(/,/).filter(item => parseInt(item, 10) === item).map(function (str, i) {
        const url = `/show-software/${str}`;
        return <li key={Math.random()} title={"Titel"}><Link to={url}>{"referenzierte Software " + (i + 1)}</Link></li>;
      })
    })
    this.getReferencedSoftwareNames(nextProps.referenced_software.toString());
  }

  getReferencedSoftwareNames(ids) {
    var self = this;
    const url = `/api/get-software-names?ids=${ids}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        console.error('Could not fetch referenced software names.', exception);
      });

    promise.then(function (json) {
      self.setState({
        names: json.map(obj => <li key={Math.random()} title={"Titel"}><Link to={`/show-software/${obj.id}`}>{`${obj.name}`}</Link></li>)
      });
      return;
    });
    return;
  }

  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <ul style={{ listStyleType: 'none', cursor: 'pointer' }}>
          <br /><div className="DetailDiv"><br />{this.state.names}</div>
        </ul>
      </div>
    )
  }
}

class ProductSoftware extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <ul style={{listStyleType: 'none', cursor: 'pointer'}}>
          <br/><div className="DetailDiv"> <br/></div>
        </ul>
      </div>
    )
  }
}

export class ProductReviews extends Component {
  constructor(props) {
    super(props);
    this.sendReview = this.sendReview.bind(this);
    this.getReview = this.getReview.bind(this);
    this.getAllReviews = this.getAllReviews.bind(this);
    this.state={rating: 0,
                review: '',
                uuid: '',
                reviews: [],
                owner: ''}
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.uuid !== undefined && nextProps.uuid !== null && nextProps.uuid !== '' && nextProps.uuid !== this.state.uuid) {
      this.getReview(nextProps.uuid);
      this.setState({uuid: nextProps.uuid});
    }
  }

  getReview(uuid) {
    var self = this;
    var url = `/api/get-review?uuid=${uuid}`;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    fetch(url, {method: 'GET',
                              headers: headers,
    })
      .then(response => response.json())
      .catch(function(exception) {
        console.error(`Could not create review node!`, exception);
      })
      .then(json => json !== undefined ?  self.setState({rating: json.rating !== undefined ? json.rating : 0 ,
                                   review: json.review !== undefined ? json.review : '',
                                   owner: json.product_owner}) : json)
  }


  sendReview() {
    if (window.confirm('Ihre Bewertung tatsächlich abschicken?')) {
      var url = '/api/add-review';
      var headers = util.defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {method: 'POST',
                                headers: headers,
                                body: `uuid=${this.props.uuid}&rating=${this.state.rating}&review=${this.state.review}`
      })
        .then(response => response.json())
        .catch(function(exception) {
          alert('Konnte das Review nicht in der Datenbank anlegen!');
          console.error(`Could not create review node!`, exception);
        })
        .then(json => alert('Ihre Bewertung wurde aktualisiert. (Neu laden um die durchschnittliche Bewertung zu sehen.)'));
    }
  }

  getAllReviews(uuid) {
    var self = this;
    var url = `/api/get-all-reviews?uuid=${uuid}`;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    fetch(url, {method: 'GET',
                              headers: headers,
    })
      .then(response => response.json())
      .catch(function(exception) {
        console.error(`Could not get reviews!`, exception);
      })
      .then(json => self.setState({reviews: json}))
  }

  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        {
          !util.isGuestUser() && JSON.parse(localStorage.getItem('user')).username !== this.state.owner &&
          <div>
            <br />
            <div>
              <div className="LabelAndStar">
              <label className="DetailDiv">Ihre Bewertung für das Produkt</label>
               <Stars notifyRatingChanged={value => this.setState({rating: value})} rating={this.state.rating} />
              </div>
              <div className="DetailDiv ReviewDivText">Bemerkungen</div>
              <textarea className="RatingContent marginTop10" id="mobilRatingContent" value={this.state.review} placeholder="" onChange={event => this.setState({review: event.target.value})} />
            </div>
            <div className="ToEndRightV2 marginTop2">
              <span onClick={event => this.sendReview()} ><ProductDetailsButton link="/" text="Bewertung abschicken" /></span>
            </div>
          </div>
        }

          <div className="DetailDiv padding2">
            <label>alle Bewertungen</label>
            <div className="button margin-left">
              <div onClick={event => this.getAllReviews(this.state.uuid)}>{this.state.review === [] ? 'laden' : 'neu laden'}</div>
            </div>
             {this.state.reviews.map( (obj,i) => <ReviewEntry key={i} rating={obj.rating} review={obj.review} /> )}
          </div>
      </div>
    )
  }
}

export class ProductMedia extends Component {
  constructor(props) {
    super(props);
    this.downloadLink = this.downloadLink.bind(this);
    this.getFileInfo = this.getFileInfo.bind(this);

    this.state = {
      fileName: null,
      uuid: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.uuid !== this.state.uuid && nextProps.uuid !== undefined) {
      this.getFileInfo(nextProps.uuid);
    }
  }

  getFileInfo(uuid) {
    var self = this;
    fetch(`/api/get-file-infos?uuids=${uuid}`, {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Could not get file infos. ", error))
      .then(function(json) {
        self.setState({
          fileName: json[0].fileName,
          uuid: uuid
        })
      });
  }


  downloadLink() {
    return `${window.location.protocol}//${window.location.host}/${this.state.uuid}/${this.state.fileName}`;
  }

  render() {
    return (
      <div className="ProductDescriptionDocument ProductMedia" style={this.props.style}>
        {this.state.uuid === null ? <div className="DetailDiv"><label calssName="openSans" >Dokumentation </label> </div> : <div className="DetailDiv"><label >Dokumentation </label> <br /> <div style={{margin: '10px'}}><span style={{fontWeight: 'bold', color: '#1F6A81'}}>{this.state.fileName}</span> <span><Link to={this.downloadLink()} target="_blank"> ↓ </Link></span></div></div>}
      </div>
    )
  }
}

export class ProductMediaMultiParent extends Component {

  render() {
    return (
      <div className="ProductDescriptionDocument ProductMedia" style={this.props.style}>
        <div className="DetailDiv">
          <ProductMediaMulti
              heading={this.props.heading1}
              uuids={this.props.uuids1}
          />
          <ProductMediaMulti
              heading={this.props.heading2}
              uuids={this.props.uuids2}
          />
          <ProductMediaMulti
              heading={this.props.heading3}
              uuids={this.props.uuids3}
          />
        </div>
      </div>
    )
  }
}

export class ProductMediaMulti extends Component {
  constructor(props) {
    super(props);
    this.downloadLink = this.downloadLink.bind(this);
    this.getFileInfo = this.getFileInfo.bind(this);
    this.downloadElements = this.downloadElements.bind(this);
    var splitted = this.props.uuids.split(/,/);
    this.state = {
      length: splitted.length,
      fileNames: splitted.map(item => null),
      uuids: splitted.map(item => null)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.uuids !== this.state.uuids && nextProps.uuids !== undefined) {
      this.getFileInfo(nextProps.uuids);
    }
  }

  getFileInfo(uuids) {
    var self = this;
    fetch(`/api/get-file-infos?uuids=${uuids}`, {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Could not get file infos. ", error))
      .then(function (json) {
        var length = json.length;
        var newFilenames = json.map(obj => (obj !== null) ? obj.fileName : null);
        var newUUIDs = json.map(obj => (obj !== null) ? obj.uuid : null);
        var newValue = '';
        for (var i = 0; i < length; i++) {
          newValue = newValue.concat(newUUIDs[i] !== null ? newUUIDs[i].toString() : '');
          if (i + 1 < length) {
            newValue = newValue.concat(',');
          }
        }

        self.setState({
          length: length,
          fileNames: newFilenames,
          uuids: newUUIDs,
        })
      });
  }

  downloadLink(i) {
    return `${window.location.protocol}//${window.location.host}/${this.state.uuids[i]}/${this.state.fileNames[i]}`;
  }

  downloadElements() {
    var self = this;
    return this.state.fileNames.map(function (fileName, i) {
      if(fileName !== null){
        return (
          <div key={i} style={{ margin: '10px' }}><span style={{ fontWeight: 'bold', color: 'green' }}>{fileName}</span>
            <span className="MediaDownloadArrow"><Link to={self.downloadLink(i)} target="_blank"> ↓ </Link></span>
          </div>
        )
      }
      return null;
    })
  }

  render() {
    return (
      <div >
        {this.state.uuids !== null && this.state.uuids !== undefined ? <div ><label ><br />{this.props.heading} </label> <br />
        {this.downloadElements()}</div> : <div ><label ><br />{this.props.heading} </label> </div>}
      </div>
    )
  }
}



export class ProductPrice extends Component {
  render() {
    return (
      <div className="Bold" >
        <label className="">Preis</label><span className="FontBlue marginLeft1"> {this.props.price} &#8364;</span>
      </div>
    );
  }
}

export class TenderPrice extends Component {
  render() {
    return (
      <div >
        <label className="Bold">Finanzielle Größenordnung: </label> <span className="FontBlue marginLeft1">{this.props.price}</span>
      </div>
    );
  }
}



export class ProductPriceService extends Component {
  render() {
    return (
      <div >
        <label className="nanoSans">Preis von: </label> {this.props.price_from} &#8364;
        <label className="nanoSans"> bis: </label> {this.props.price_to} &#8364;
      </div>
    );
  }
}

export class SoftwareStatistics extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>wurde das Produkt schon erfolgreich eingesetzt </label> <br /><span className="ProductDetailAnswers">{this.props.successful_deployment === true ? 'Ja' : 'Nein'} </span><br /><span className="ProductDetailAnswers"> {this.props.successful_deployment_description}</span><br /></div>
        <br /><div className="DetailDiv"><label>welche sind die Einsatzbereiche Ihre Software </label> <br /><span className="ProductDetailAnswers">{this.props.clinic_desc}</span><br /><br /></div>
        <br /><div className="DetailDiv"><label>wieviele Nutzer hat Ihre Software </label> <br /><span className="ProductDetailAnswers">{this.props.user_number}</span><br /></div>
        <br /><div className="DetailDiv"><label>wieviele davon sind Kliniken </label> <br /><span className="ProductDetailAnswers">{this.props.clinic_number} </span><br /> <span>{this.props.clinic_count_description}</span><br /></div>
        <br /><div className="DetailDiv"><label>mittlere Zufriedenheit der Nutzer </label> <br /><span className="ProductDetailAnswers">{this.props.satisfaction_rate}</span> <br /><span> {this.props.rating_desc}</span><br /></div>
        <br /><div className="DetailDiv"><label>seit wann ist das Produkt in Nutzung </label> <br /><span className="ProductDetailAnswers">{this.props.date}</span><br /></div>
        <br /><div className="DetailDiv"><label>persönliche Komplexitätsbewertung </label> <br /><span className="ProductDetailAnswers">{this.props.complexity_rate}</span><br /></div>
      </div>
    )
  }
}

export class ProductReferenceSoftwareNew extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>vorhandene Referenzen </label> <br /><span className="ProductDetailAnswers">{this.props.has_customer_reference === true ? 'Ja' : 'Nein'}  </span><br /><span className="ProductDetailAnswers"> {this.props.customer_reference}</span><br /></div>
      </div>
    )
  }
}

export class ProductDescriptionResearchSoftware extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Beschreibung </label> <br /><span className="ProductDetailAnswers">{this.props.desc} <br /><br /></span></div>
        <br /><div className="DetailDiv"><label>Typ der Software </label> <br /><span className="ProductDetailAnswers">{this.props.researchtype} <br /><br /></span></div>
        <br /><div className="DetailDiv"><label>Wofür wurde die Software geschrieben? </label> <br /><span className="ProductDetailAnswers"> {this.props.aim}<br /></span></div>
        <br /><div className="DetailDiv"><label>Funktionsbeschreibung </label> <br /><span className="ProductDetailAnswers">{this.props.functionality} <br /></span></div>
        <br /><div className="DetailDiv"><label>Besonderheiten der Software </label> <br /><span className="ProductDetailAnswers">{this.props.specialties} <br /></span></div>
        <br /><div className="DetailDiv"><label>Zielgruppe der Software </label> <br /><span className="ProductDetailAnswers">{this.props.target}<br /></span></div>
        <br /><div className="DetailDiv"><label>Wo wurde die Software verwendet? </label> <br /><span className="ProductDetailAnswers">{this.props.usage}<br /></span></div>
        <br /><div className="DetailDiv"><label>Ein eigenstehendes Produkt oder eine Implementation </label> <br /><span className="ProductDetailAnswers">{this.props.is_standalone_sw === true ? 'Ja' : 'Nein'} <br /> {this.props.standalone_sw} <br /></span></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags}<br /></span></div>
      </div>
    )
  }
}

export class ProductDescriptionDocument extends Component {
  render() {
    return (
      <div className="ProductDescriptionDocument" style={this.props.style}>
        <br /><div className="DetailDiv"><label>Wofür wurde das Dokument geschrieben? </label> <br /><span className="ProductDetailAnswers">{this.props.aim} <br /></span></div>
        <br /><div className="DetailDiv"><label>Typ des Dokumentes </label> <br /><span className="ProductDetailAnswers">{this.props.doctype} </span><br /></div>
        <br /><div className="DetailDiv"><label>Inhalt des Dokumentes </label> <br /><span className="ProductDetailAnswers">{this.props.content}</span> <br /></div>
        <br /><div className="DetailDiv"><label>Links </label> <br /><span className="ProductDetailAnswers">{this.props.links}</span> <br /></div>
        <br /><div className="DetailDiv"><label>Tags </label> <br /><span className="ProductDetailAnswers">{this.props.tags} </span><br /></div>
        <br /><div className="DetailDiv"><label>Die Zielgruppe des Dokumentes </label> <br /><span className="ProductDetailAnswers">{this.props.target} </span><br /></div>
        <br /><div className="DetailDiv"><label>Besonderheiten des Dokumentes </label> <br /><span className="ProductDetailAnswers">{this.props.specialties} </span><br /></div>
        <br /><div className="DetailDiv"><label>Wo wurde das Dokument verwendet? </label> <br /><span className="ProductDetailAnswers">{this.props.usage} </span><br /></div>
        <br /><div className="DetailDiv"><label>Sind die Dokumente z.B. bereits der DFG oder einer Wirtschaftsprüfungsgesellschaft vorgelegt worden? </label> <br /><span className="ProductDetailAnswers">{this.props.review1}</span> <br /></div>
        <br /><div className="DetailDiv"><label>Sind die Dokumente schon einmal erfolgreich begutachtet worden? Wenn ja, von wem?</label> <br /><span className="ProductDetailAnswers">{this.props.review2} </span><br /></div>
      </div>
    )
  }
}

export class CommUserInfo extends Component {

  constructor(props) {
    super(props);

    this.getProductInfo = this.getProductInfo.bind(this);

    this.state = {
      id: this.props.id,
      table: this.props.table,
      role_name: '',
      user_name: '',
      email: '',
      company: ''
    }
    this.getProductInfo(this.state.table, this.state.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.state.id || nextProps.table !== this.state.table) {
      this.setState({
        id: nextProps.id,
        table: nextProps.table
      })
    }
  }

  getProductInfo(table, id) {
    var self = this;
    fetch(`/api/get-product-info?table=${table}&id=${id}`, {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Could not get product infos. ", error))
      .then(function (json) {
        self.setState({
          role_name: (json[0].name ? json[0].name : ' (keine Angabe)'),
          user_name: (json[0].user_name ? json[0].user_name : ' (keine Angabe)'),
          email: (json[0].email ? json[0].email : ' (keine Angabe)'),
          company: (json[0].company ? json[0].company : ' (keine Angabe)')
        })
      });
  }


  render() {
    if (this.state.role_name === 'commercial') {
      return (
        <div>
          <label className="Bold" > Firma <span className="FontBlue marginLeft1"> {this.state.company} </span> </label><br />
          <label className="Bold"> E-mail <span className="FontBlue marginLeft1"> {this.state.email} </span></label>
        </div>
      )
    } else {
      return (
        <div> </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/product-details.js